
export const isProdEnv = () => {
  let URL = window._env_.REACT_APP_BROKER_API_URL;
  let env = URL.split('/');
  env = env[3];
  env = env.replace('-broker', '');

  if (['staging', 'pre-prod', 'dev', 'qat'].includes(env)) {
    return false;
  }
  return true;
};

export const isChatFeatureEnv = () => {
  let URL = window._env_.REACT_APP_BROKER_API_URL;
  let env = URL.split('/');
  env = env[3];
  env = env.replace('-broker', '');

  if (['staging', 'qat'].includes(env)) {
    return true;
  }
  return false;
};

const getQueryParam = (name) => {
  try {
    return new URLSearchParams(window.location.search).get(name);
  } catch (e) {
    return null;
  }
};

/** Engine iframe must not load chat JS or open the chat websocket. */
export const isEngineModeForChat = () => {
  if (getQueryParam('isShipment') === 'true') {
    return false;
  }
  return !!(
    getQueryParam('onlyOneShipment') ||
    (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('onlyOneShipment')) ||
    window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN === 'kxEngineBrokerToken'
  );
};

export const showChatApp = () => isChatFeatureEnv() && !isEngineModeForChat();
